import React, { type ComponentType } from "react";
import { useIntl, type IntlShape } from "react-intl";

export type WithIntlProps = { intl: IntlShape };

export default function injectIntl<P extends WithIntlProps>(
  WrappedComponent: ComponentType<P>
) {
  type OuterProps = Omit<P, "intl">;

  function IntlInjector(props: OuterProps) {
    const intl = useIntl();
    return <WrappedComponent {...(props as P)} intl={intl} />;
  }

  IntlInjector.displayName = `injectIntl(${
    WrappedComponent.displayName || WrappedComponent.name || "Component"
  })`;

  return IntlInjector as ComponentType<OuterProps>;
}
